import React, { Component } from "react";
import PropTypes from 'prop-types';

//import './file-upload.scss';

class FileUpload extends Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    componentDidMount() {
        if (this.props.defaultValue && this.props.defaultValue !== '') $(this.container).addClass('has-file');
    }

    onDelete(e) {
        this.fileupload.value = null;

        this.props.onDelete();

        $(this.container).removeClass('has-file');
    }

    onChange(e) {
        let el = e.target,
            file = el.files[0];

        if (this.props.type === 'image') {
            if (/image\/png|image\/jpg|image\/jpeg/.test(file.type)) {
                let reader = new FileReader();

                reader.onload = () => {
                    // send data back to parent
                    this.props.onSelect(file, reader.result, el);

                    $(this.container).addClass('has-file');
                };

                reader.readAsDataURL(file);
            } else console.log("File not supported!");

        } else {
            // *.mp4, text files, *.mp3, office files (*.docx, *.xls, ...), *.zip, *.pdf
            if (/video\/mp4|text\/plain|audio\/mpeg|application\/vnd.*|application\/x-zip-compressed|application\/pdf/.test(file.type)) {
                // send data back to parent
                this.props.onSelect(file, null, el);

                $(this.container).addClass('has-file');

            } else console.log("File not supported!");
        }
    }

    render() {
        return (
            <div ref={(el) => this.container = el} className="file-upload">
                {
                    this.props.type === 'image'
                        ? <img ref={(el) => this.img = el} src={this.props.defaultValue} />
                        : <span>{this.props.defaultValue}</span>
                }

                <i className='icon-add' onClick={() => this.fileupload.click()} />
                <i className="icon-close" onClick={this.onDelete} />

                <input type="file"
                    ref={(el) => this.fileupload = el}
                    onChange={this.onChange} />
            </div>
        )
    }
}

FileUpload.defaultProps = {
    type: 'image'
};

FileUpload.propTypes = {
    defaultValue: PropTypes.string,
    type: PropTypes.oneOf(['image', 'file']),
    onDelete: PropTypes.func,
    onSelect: PropTypes.func
};

export default FileUpload;